import React from 'react';
import PropTypes from 'prop-types';
import styles from './RetailerImage.module.scss';
import cn from 'classnames';

function RetailerImage(props) {
  const { image, name, size } = props;
  let small = false;
  let extraSmall = false;

  const style = {};

  if (size) {
    style.width = `${size}px`;
    style.height = `${size}px`;
    small = parseInt(size, 10) < 200;
    extraSmall = parseInt(size, 10) < 50;
  }

  return (
    <div className={cn(styles.retailerImage, props.inline ? styles.inline : '')} style={style}>
      {image ? (
        <img alt={name} src={image} />
      ) : (
        <div className={cn(styles.retailerName, small ? styles.small : '', extraSmall ? styles.extraSmall : '')}>
          {name}
        </div>
      )}
    </div>
  );
}

export default RetailerImage;

RetailerImage.defaultProps = {
  inline: false,
  name: '',
};

RetailerImage.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inline: PropTypes.bool,
};
